import { render } from "./StyleProfilesDashboard.vue?vue&type=template&id=37bf7cec&scoped=true"
import script from "./StyleProfilesDashboard.vue?vue&type=script&lang=js"
export * from "./StyleProfilesDashboard.vue?vue&type=script&lang=js"

import "./StyleProfilesDashboard.vue?vue&type=style&index=0&id=37bf7cec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37bf7cec"]])

export default __exports__